import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadAuftragTerminListStatus: 'idle',
    loadAuftragTerminListError: undefined as any,
    loadAuftragTerminListLastArgs: undefined as any,
    loadAuftragTerminStatus: 'idle',
    loadAuftragTerminError: undefined as any,
    saveAuftragTerminStatus: 'idle',
    saveAuftragTerminError: undefined as any,
    deleteAuftragTerminStatus: 'idle',
    deleteAuftragTerminError: undefined as any,

    auftragTerminList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadAuftragTerminList = createAsyncThunk('auftragTerminModuleSlice/loadAuftragTerminList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragTerminModuleSlice.loadAuftragTerminListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremtermin/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragTerminListStatus } = getState().auftragTerminModuleSlice
        return loadAuftragTerminListStatus !== 'pending'
    }
})

export const loadAuftragTermin = createAsyncThunk('auftragTerminModuleSlice/loadAuftragTermin', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremtermin/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragTerminStatus } = getState().auftragTerminModuleSlice
        return loadAuftragTerminStatus !== 'pending'
    }
})

export const saveAuftragTermin = createAsyncThunk('auftragTerminModuleSlice/saveAuftragTermin', async ({ auftragTermin }: any, { rejectWithValue }: any) => {
    let promises = []
    if (auftragTermin?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/ncremtermin/${ auftragTermin?.HDR_ID }/`,
            prepareData(auftragTermin),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/ncremtermin/`,
            prepareData(auftragTermin),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveAuftragTerminStatus } = getState().auftragTerminModuleSlice
        return saveAuftragTerminStatus !== 'pending'
    }
})

export const deleteAuftragTermin = createAsyncThunk('auftragTerminModuleSlice/deleteAuftragTermin', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/ncremtermin/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteAuftragTerminStatus } = getState().auftragTerminModuleSlice
        return deleteAuftragTerminStatus !== 'pending'
    }
})

const AuftragTerminSlice = createSlice({
    name: 'auftragTerminModuleSlice',
    initialState,
    reducers: {
        resetloadAuftragTerminListError: (state) => {
            state.loadAuftragTerminListError = undefined
        },
        resetloadAuftragTermin: (state) => {
            state.formItem = undefined
            state.loadAuftragTerminError = undefined
        },
        resetloadAuftragTerminError: (state) => {
            state.loadAuftragTerminError = undefined
        },
        resetsaveAuftragTermin: (state) => {
            state.formItem = undefined
            state.saveAuftragTerminError = undefined
        },
        resetsaveAuftragTerminError: (state) => {
            state.saveAuftragTerminError = undefined
        },
        resetdeleteAuftragTerminError: (state) => {
            state.deleteAuftragTerminError = undefined
        },
        removeFromAuftragTerminListById: (state, action) => {
            state.auftragTerminList = state.auftragTerminList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromAuftragTerminListByIds: (state, action) => {
            state.auftragTerminList = state.auftragTerminList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.auftragTerminList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAuftragTerminListStatus = 'preloaded'
            state.loadAuftragTerminListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.auftragTerminList = []
            state.loadAuftragTerminListStatus = 'idle'
            state.loadAuftragTerminListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAuftragTerminList.pending, (state) => {
            state.loadAuftragTerminListStatus = 'pending'
            state.loadAuftragTerminListError = undefined
        })
        builder.addCase(loadAuftragTerminList.fulfilled, (state, action) => {
            state.loadAuftragTerminListStatus = 'idle'

            if (!action.payload) { return }

            state.loadAuftragTerminListLastArgs = action.payload.args

            {
                state.auftragTerminList = action.payload.data

            }
        })
        builder.addCase(loadAuftragTerminList.rejected, (state, action) => {
            state.loadAuftragTerminListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragTerminListError = action.error.message
            } else {
                state.loadAuftragTerminListError = action.payload
            }
        })

        builder.addCase(loadAuftragTermin.pending, (state) => {
            state.loadAuftragTerminStatus = 'pending'
            state.loadAuftragTerminError = undefined
        })
        builder.addCase(loadAuftragTermin.fulfilled, (state, action) => {
            state.loadAuftragTerminStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragTerminList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragTerminList.push(newItem) }
                else { state.auftragTerminList[i] = { ...state.auftragTerminList[i], ...newItem } }
            }
        })
        builder.addCase(loadAuftragTermin.rejected, (state, action) => {
            state.loadAuftragTerminStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragTerminError = action.error.message
            } else {
                state.loadAuftragTerminError = action.payload
            }
        })

        builder.addCase(saveAuftragTermin.pending, (state) => {
            state.saveAuftragTerminStatus = 'pending'
            state.saveAuftragTerminError = undefined
        })
        builder.addCase(saveAuftragTermin.fulfilled, (state, action) => {
            state.saveAuftragTerminStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragTerminList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragTerminList.push(newItem) }
                else { state.auftragTerminList[i] = { ...state.auftragTerminList[i], ...newItem } }
            }
        })
        builder.addCase(saveAuftragTermin.rejected, (state, action) => {
            state.saveAuftragTerminStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveAuftragTerminError = action.error.message
            } else {
                state.saveAuftragTerminError = action.payload
            }
        })

        builder.addCase(deleteAuftragTermin.pending, (state) => {
            state.deleteAuftragTerminStatus = 'pending'
            state.deleteAuftragTerminError = undefined
        })
        builder.addCase(deleteAuftragTermin.fulfilled, (state, action) => {
            state.deleteAuftragTerminStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.auftragTerminList = state.auftragTerminList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.auftragTerminList = state.auftragTerminList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteAuftragTermin.rejected, (state, action) => {
            state.deleteAuftragTerminStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteAuftragTerminError = action.error.message
            } else {
                state.deleteAuftragTerminError = action.payload
            }
        })

    }
})

export const {
    resetloadAuftragTerminListError,
    resetloadAuftragTermin,
    resetloadAuftragTerminError,
    resetsaveAuftragTermin,
    resetsaveAuftragTerminError,
    resetdeleteAuftragTerminError,
    removeFromAuftragTerminListById,
    removeFromAuftragTerminListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = AuftragTerminSlice.actions
export default AuftragTerminSlice.reducer
